<template>
	<div class="footer-terms">
		<div class="footer-terms__all-rights-reserved">
			<span class="footer-terms__text">CarFree {{ currentYear }} © {{ $t('components.footer.terms.all_rights_reserved') }}</span>
		</div>
		<div class="footer-terms__container footer-terms__container--images">
			<GlobalImage src="eu-funds.png" alt="eu-funds" provider="none" :width="68" :height="40" />
			<GlobalImage src="republic-of-poland.png" alt="republic-of-poland" provider="none" :width="93" :height="40" />
			<GlobalImage src="eu.png" alt="eu" provider="none" :width="120" :height="40" />
		</div>
		<div class="footer-terms__container footer-terms__container--links">
			<a class="footer-terms__text" rel="nofollow" :href="localePath('privacy-policy')">{{ $t('components.footer.terms.privacy_policy') }}</a>
			<a class="footer-terms__text" rel="nofollow" :href="localePath('terms-of-service')">{{ $t('components.footer.terms.site_terms') }}</a>
			<a class="footer-terms__text" rel="nofollow" :href="localePath('general-terms-and-conditions')">{{
				$t('components.footer.terms.contract_terms')
			}}</a>
		</div>
	</div>
</template>
<script lang="ts" setup>
const localePath = useLocalePath()
const currentYear = new Date().getFullYear()
</script>
<style scoped lang="scss" src="./Terms.scss"></style>
